// ///////////////////////////////////////////////////////////////////////////////
// NOTA BENE:                                                                   //
//                                                                              //
// These numbers come from the Illustrator .ai files, from the exact dimensions //
// of the picture blocks. They are used here to get the exact ratio, eg. 97/190 //
// and not 51% or 51.05% or whichever decimal one wishes to stop at.            //
//                                                                              //
// ///////////////////////////////////////////////////////////////////////////////

const XS = 'XS';
const S = 'S';
const M = 'M';
const L = 'L';
const XL = 'XL';
const XXL = 'XXL';
const SQUARE = 'SQUARE';
const R_38_BY_28 = 'R_38_BY_28';
const R_38_BY_58 = 'R_38_BY_58';
const R_63_BY_58 = 'R_63_BY_58';
const R_65_BY_48 = 'R_65_BY_48';
const R_13_BY_12 = 'R_13_BY_12';
const R_1_BY_5 = 'R_1_BY_5';

// height over width
// approx. values are provided to find the closest ratio when encountering one in the mockups

export const RATIO_VALUES = {
  [XS]: 180 / 580, // ~0,31
  [S]: 118 / (380 - 118), // ~0,45
  [M]: 194 / 380, // ~0,51
  [L]: 9 / 16, // ~ 0,56
  [XL]: 240 / 380, // ~ 0,63
  [XXL]: 320 / 480, // ~ 0,67
  [SQUARE]: 1,
  [R_38_BY_28]: 380 / 280, // ~ 1,36
  [R_38_BY_58]: 380 / 580, // ~ 0,655
  [R_63_BY_58]: 63 / 58, // ~ 1,09
  [R_65_BY_48]: 65 / 48, // ~ 1,35
  [R_13_BY_12]: 13 / 12, // ~ 1,08
  [R_1_BY_5]: 1 / 5, // ~ 0,2
};

export const RATIOS = {
  [XS]: '58 / 18', // ~0,31
  [S]: '262 / 118', // ~0,45
  [M]: '380 / 194', // ~0,51
  [L]: '16 / 9', // ~ 0,56
  [XL]: '380 / 240', // ~ 0,63
  [XXL]: '480 / 320', // ~ 0,67
  [SQUARE]: '1 / 1',
  [R_38_BY_28]: '28 / 38', // ~ 1,36
  [R_38_BY_58]: '58 / 38', // ~ 0,655
  [R_63_BY_58]: '58 / 63', // ~ 1,09
  [R_65_BY_48]: '48 / 65', // ~ 1,35
  [R_13_BY_12]: '12 / 13', // ~ 1,08
  [R_1_BY_5]: '5 / 1', // ~ 0,2
};

export default {
  VALUES: RATIO_VALUES,
  XS,
  S,
  M,
  L,
  XL,
  XXL,
  SQUARE,
  R_38_BY_28,
  R_38_BY_58,
  R_63_BY_58,
  R_65_BY_48,
  R_13_BY_12,
  R_1_BY_5,
};
